import { Injectable, inject } from '@angular/core';
import {ActivatedRouteSnapshot} from '@angular/router';
import {JobboardAdapter} from '../adapters/jobboard.adapter';
import {Observable, catchError, of} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MissingDataResolver {
  private adapter = inject(JobboardAdapter);

  resolve(route: ActivatedRouteSnapshot): Observable<object> {
    return this.adapter.getMissingData(route.params['applicationId'], route.queryParams['nonce']).pipe(
      catchError(error => {
        if (error.status === 403) {
          return of(undefined);
        }
        throw error;
      })
    );
  }
}
